import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import JobAias from '../job/tasks/JobAias'

const propTypes = {}

class AiasContainer extends Component {
  render() {
    return <JobAias {...this.props} fromDashboard={true} user={this.props.authentication.user} />
  }
}

const mapStateToProps = ({ authentication }, ownProps) => ({
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}), dispatch)
})

AiasContainer.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AiasContainer))



// WEBPACK FOOTER //
// ./src/containers/dashboard/AiasContainer.js